import React from "react";

const faqitem = ({ target, title, content }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={"#" + target}
        >
          <p className="lead">{title}</p>
        </button>
      </h2>
      <div
        id={target}
        className="accordion-collapse collapse text-start"
        data-bs-parent="#questions"
      >
        <div className="accordion-body">{content}</div>
      </div>
    </div>
  );
};

export default faqitem;
